import { mapActions, mapState } from "vuex";
import { 
// clearAccountLookupForm,
getAccountLookupForm, setAccountLookupForm, } from "@/store/modules/accountLookup";
import GoogleLogin from "vue-google-login";
import { featureToggleMixin } from "@/mixins";
import mixins from "vue-typed-mixins";
import { UNKNOWN_ERROR } from "@/content";
import dayjs from "dayjs";
import { getAccountType } from "./_partials/helpers";
import { Card, Button, Hyperlink, Alert } from "@/components";
import accountLookupResultMixin from "./_partials/accountLookupResultMixin";
const AccountNotFound = () => import("./_partials/AccountNotFound.vue");
const AccountForm = () => import("./_partials/AccountForm.vue");
const ChangePrivateEmail = () => import("./_partials/ChangePrivateEmail.vue");
const AccountResult = () => import("./_partials/AccountResult.vue");
const testAccountParams = {
    npsn: "10900867",
    tanggal_lahir: "2011-10-19",
    recaptcha_token: "",
    nama_ibu: "Gigi",
};
function genTestAccounts(name = "Galih") {
    return Array.from({ length: 5 }, (v, k) => ({
        nama: `${name}${k + 1}`,
        ...testAccountParams,
    }));
}
const tests = [
    ...genTestAccounts("Galih"),
    ...genTestAccounts("Edgi"),
];
export default mixins(featureToggleMixin, accountLookupResultMixin).extend({
    components: {
        GoogleLogin,
        Card,
        Button,
        Hyperlink,
        Alert,
        AccountNotFound,
        AccountForm,
        ChangePrivateEmail,
        AccountResult,
    },
    data: () => ({
        error: {
            code: 0,
            message: "",
        },
        requestingPassword: false,
        alert: {
            message: "",
            type: "",
        },
        loginAccountUrl: "https://accounts.google.com/AccountChooser?hd=wartek.belajar.id",
        skipLoading: false,
        isError: false,
    }),
    computed: {
        ...mapState("accountLookup", ["form", "result", "loading"]),
        isLocal() {
            return (process.env.NODE_ENV === "development" || !!this.$route.query.show_test_buttton);
        },
        visibleForm() {
            /* eslint-disable @typescript-eslint/no-unused-vars */
            const { placeOfBirth, ...rest } = this.form;
            return rest;
        },
        hasUser() {
            const hasForm = Object.keys(this.form).some((key) => !!this.form[key]);
            return Boolean(this.form) && Boolean(hasForm) && Boolean(this.result);
        },
        localForm() {
            return getAccountLookupForm();
        },
        testIndex() {
            return Number(this.$route.query.test);
        },
        showSidebar() {
            return this.TOGGLES.accountCreation ? !!this.result : true;
        },
    },
    beforeDestroy() {
        // clearAccountLookupForm();
    },
    async mounted() {
        await this.$recaptchaLoaded();
        const recaptcha = this.$recaptchaInstance;
        recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.hideBadge();
        this.lookupAccount();
    },
    methods: {
        ...mapActions("accountLookup", ["lookup"]),
        /* eslint-disable @typescript-eslint/no-explicit-any */
        onSuccess(googleUser) {
            // console.log(googleUser);
            // This only gets the user information: id, name, imageUrl and email
            // console.log(googleUser.getBasicProfile());
            const user = googleUser.it.HU;
            this.alert.type = "success";
            this.alert.message = `Selamat datang ${user}`;
        },
        /* eslint-disable @typescript-eslint/no-explicit-any */
        onFailure(e) {
            this.alert.type = "error";
            this.alert.message = e.message || UNKNOWN_ERROR;
        },
        async lookupAccount(skipLoading = false) {
            this.skipLoading = skipLoading;
            const form = { ...this.form, ...this.localForm };
            const test = this.testIndex;
            const isInvalid = Object.values(form).some((val) => val === "");
            if (isInvalid) {
                return this.$router.push("/");
            }
            if (test > -1) {
                this.testAccount(test);
            }
            else if (this.form) {
                const recaptchaToken = await this.$recaptcha("homepage");
                const res = await this.lookup({
                    type: getAccountType(),
                    body: {
                        nama: form.fullName || form.nama,
                        npsn: form.npsn,
                        nama_ibu: form.motherName,
                        // nik: form.nik,
                        tanggal_lahir: form.dateOfBirth,
                        recaptcha_token: recaptchaToken,
                    },
                    clearResultFirst: !skipLoading,
                });
                this.trackEvent(res);
                this.handleError(res);
            }
        },
        trackEvent(res) {
            let title;
            if (res.status === 200) {
                title = "Belajar.id | Account Lookup Success";
            }
            else {
                title = "Belajar.id | Account Lookup Failed";
            }
            this.$gtag.pageview({
                page_title: title,
                page_path: this.$route.path,
                page_location: window.location.href,
                // page_referrer: document.referrer,
                // campaign: "",
                // medium: "",
                // activity_type: "page_view",
                // session_start: "",
                // first_visit: "",
                // engagement_time_msec: "",
            });
        },
        handleError(res) {
            this.isError = true;
            if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                this.error = {
                    code: res.status,
                    message: "Captcha tidak valid",
                };
            }
        },
        async testAccount(index) {
            const recaptchaToken = await this.$recaptcha("homepage");
            const type = index >= 5 ? "ptk" : "pd";
            const testData = {
                ...(tests[index] || {}),
                recaptcha_token: recaptchaToken,
            };
            // save to local storage
            setAccountLookupForm({
                fullName: testData.nama,
                motherName: testData.nama_ibu,
                npsn: testData.npsn,
                dateOfBirth: dayjs(testData.tanggal_lahir).format("YYYY-MM-DD"),
                userType: type === "ptk" ? "teacher" : "student",
                recaptchaToken,
            });
            const res = await this.lookup({
                type,
                body: testData,
            });
            this.handleError(res);
        },
    },
});
